import React, { useState } from "react";
import { getCookie, getUserRole } from "../authfile";
import { QueryClient, QueryClientProvider } from "react-query";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ThemeProvider, createTheme } from "@mui/material";
import { SnackbarProvider } from "notistack";
import { ReactQueryDevtools } from 'react-query/devtools'
import { ADMIN, NONE, TECHNICIAN } from "../constants/routeConstants";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../hooks/UserContext";

const theme = createTheme({
    palette: {
      primary: {
        main: "#002277",
      },
      secondary: {
        main: "#ffffff",
      },
      teritary: {
        main: "#D9F6FA"
      }
    },
    typography: {
      fontFamily: 'Arial',
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontFamily: 'Arial',
          },
        },
      },
    },
  
  });
const queryClient = new QueryClient();

export const ThemeClient = ({children}) => {
  let userRole = NONE;
  const [code, setCode] = useState('');
  const userInfoData = JSON.parse(getCookie('userInfo'));

  if (userInfoData && userInfoData?.msad_groups.includes(process.env.REACT_APP_SECURE_GROUP_ADMIN)) {
    userRole = ADMIN
  } else if (userInfoData && userInfoData?.msad_groups.includes(process.env.REACT_APP_SECURE_GROUP_TECH)) {
    userRole = TECHNICIAN
  } else {
    userRole = NONE;
  }
  //userRole = NONE

    return (
      <UserContext.Provider value={{ userRole, code, setCode }}>
        <SnackbarProvider>
          <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <QueryClientProvider client={queryClient}>
            {children}
            <ReactQueryDevtools />
            </QueryClientProvider>
            </LocalizationProvider>
          </ThemeProvider>
        </SnackbarProvider>
        </UserContext.Provider>
    )
}
